import React, { createContext, useState, useEffect, useContext } from 'react';
import { useFirebase } from './FirebaseContext';

interface LeaveType {
  name: string;
  color: string;
  description: string;
  code: string;
  selectedallowance: string;
  type: string;
  workSchedule?: boolean;
  auto_approval?: boolean;
  doc_required?: boolean;
  is_hidden?: boolean;
  order_number?: number;
  main?: boolean;
}

interface LeaveTypeContextProps {
  leaveTypes: LeaveType[];
  setLeaveTypes: React.Dispatch<React.SetStateAction<LeaveType[]>>;
}

interface LeaveTypeProviderProps {
  children: React.ReactNode;
}

const LeaveTypeContext = createContext<LeaveTypeContextProps | undefined>(
  undefined
);

export const LeaveTypeProvider: React.FC<LeaveTypeProviderProps> = ({
  children,
}) => {
  const [leaveTypes, setLeaveTypes] = useState<LeaveType[]>([]);
  const { leaveTypesData } = useFirebase();

  useEffect(() => {
    // Sort the leave types by order_number
    const sortedLeaveTypes = [...leaveTypesData].sort((a, b) => {
      // Handle undefined order_number values by treating them as highest value
      const orderA = a.order_number ?? Number.MAX_SAFE_INTEGER;
      const orderB = b.order_number ?? Number.MAX_SAFE_INTEGER;
      return orderA - orderB;
    });

    setLeaveTypes(sortedLeaveTypes);
  }, [leaveTypesData]);

  return (
    <LeaveTypeContext.Provider value={{ leaveTypes, setLeaveTypes }}>
      {children}
    </LeaveTypeContext.Provider>
  );
};

export const useLeaveTypeContext = () => {
  const context = useContext(LeaveTypeContext);
  if (context === undefined) {
    throw new Error(
      'useLeaveTypeContext must be used within a LeaveTypeProvider'
    );
  }
  return context;
};
